import React from 'react';
import lottery from '../../lottery';
import style from './DrawResult.scss';
var DrawResult = function (_a) {
    var result = _a.result;
    return React.createElement("span", { className: style['draw-result'] }, result.map(function (symbols, index) {
        return React.createElement("span", { className: style.symbol, key: index }, symbols.map(function (index) { return React.createElement("span", { key: index }, lottery.number_alphabet[index]); }));
    }));
};
export default DrawResult;
